<template>
  <label class="flex justify-start items-baseline cursor-pointer" @click.prevent="checkIt">
    <div class="check-pane box-content transform translate-y-1">
      <input type="checkbox" class="opacity-0 absolute" :checked="checked" />
      <span class="grid place-content-center">
        <ph-check class="opacity-0" :class="{ 'opacity-100': checked }" size="18" />
      </span>
    </div>
    <div>
      <span class="select-none align-top inline"><slot></slot></span>
    </div>
  </label>
</template>

<script lang="ts">
import { defineComponent, computed, ref } from 'vue'
import { PhCheck } from '@dnlsndr/vue-phosphor-icons'

export default defineComponent({
  components: {
    PhCheck,
  },
  props: {
    value: { type: [Number, String], required: true },
    uuid: { type: [Number, String], required: true },
    selectedItems: { type: Array },
    checked: { type: Boolean },
  },

  setup(props, { emit }) {
    /**
     * @returns {boolean} checked
     */
    const checked = computed(() => props.selectedItems?.includes(props.value) || props.checked)
    /**
     * @emits update:selectedItems updatedItems
     */
    const checkIt = function () {
      if (props.selectedItems) {
        // copy the item Array to avoid mutating props
        let updatedItems = [...props.selectedItems]
        // remove item if checked, else add name
        if (checked.value) {
          updatedItems.splice(updatedItems.indexOf(props.value), 1)
        } else {
          updatedItems.push(props.value)
        }
        // emit the updated item
        emit('update:selectedItems', updatedItems)
      }
      if (checked.value) {
        emit('update:selectedItem', [])
      } else {
        emit('update:selectedItem', [props.value])
      }
    }

    return { checkIt, checked }
  },
})
</script>

<style scoped>
.check-pane {
  @apply border mr-6 h-4.5 w-4.5 box-border;
}
input:checked + svg {
  display: block;
}
</style>
